const fieldDefinitionPublish = {
    key: 'PUBLISH_DICTIONARY',
    helpText: 'Publish',
    required: false,
    type: 'checkbox',
    value: 'publish',
    isSelected: true
};
const fieldDefinitionUpdate = {
    key: 'UPDATE_DICTIONARY',
    helpText: 'Update',
    required: false,
    type: 'checkbox',
    value: 'update',
    isSelected: true
};
const fieldDefinitionCreate = {
    key: 'CREATE_DICTIONARY',
    helpText: 'Create',
    required: false,
    type: 'checkbox',
    value: 'create',
    isSelected: true
};
const fieldDefinitionDelete = {
    key: 'DELETE_DICTIONARY',
    helpText: 'Delete',
    required: false,
    type: 'checkbox',
    value: 'delete',
    isSelected: true
};
const fieldDefinitionAddRow = {
    key: 'ADD_ROW',
    helpText: 'Add Row',
    required: false,
    type: 'checkbox',
    value: 'addRow',
    isSelected: true
};
const fieldDefinitionUpdateRow = {
    key: 'UPDATE_ROW',
    helpText: 'Update Row',
    required: false,
    type: 'checkbox',
    value: 'updateRow',
    isSelected: true
};
const fieldDefinitionPublishRow = {
    key: 'PUBLISH_ROW',
    helpText: 'Publish Row',
    required: false,
    type: 'checkbox',
    value: 'publishRow',
    isSelected: true
};
const fieldDefinitionArchiveRow = {
    key: 'ARCHIVE_ROW',
    helpText: 'Archive Row',
    required: false,
    type: 'checkbox',
    value: 'archiveRow',
    isSelected: true
};
const fieldDefinitionDeleteRow = {
    key: 'DELETE_ROW',
    helpText: 'Delete Row',
    required: false,
    type: 'checkbox',
    value: 'deleteRow',
    isSelected: true
};
const fieldDefinitionUpdateDictionaryMetadata = {
    key: 'UPDATE_DICTIONARY_METADATA',
    helpText: 'Update Dictionary Metadata',
    required: false,
    type: 'checkbox',
    value: 'updateDictionaryMetadata',
    isSelected: true
};
const fieldDefinitionCreateOrganization = {
    key: 'CREATE_ORGANIZATION',
    helpText: 'Create Organization',
    required: false,
    type: 'checkbox',
    value: 'createOrganization',
    isSelected: true
};
const fieldDefinitionUpdateOrganization = {
    key: 'UPDATE_ORGANIZATION',
    helpText: 'Update Organization',
    required: false,
    type: 'checkbox',
    value: 'updateOrganization',
    isSelected: true
};
const fieldDefinitionDeleteOrganization = {
    key: 'DELETE_ORGANIZATION',
    helpText: 'Delete Organization',
    required: false,
    type: 'checkbox',
    value: 'deleteOrganization',
    isSelected: true
};
const fieldDefinitionCreateOrganizationRelationship = {
    key: 'CREATE_ORGANIZATION_RELATIONSHIP',
    helpText: 'Create Organization Relationship',
    required: false,
    type: 'checkbox',
    value: 'createOrganizationRelationship',
    isSelected: true
};
const fieldDefinitionUpdateOrganizationRelationship = {
    key: 'UPDATE_ORGANIZATION_RELATIONSHIP',
    helpText: 'Update Organization Relationship',
    required: false,
    type: 'checkbox',
    value: 'updateOrganizationRelationship',
    isSelected: true
};
const fieldDefinitionDelteOrganizationRelationship = {
    key: 'DELETE_ORGANIZATION_RELATIONSHIP',
    helpText: 'Delete Organization Relationship',
    required: false,
    type: 'checkbox',
    value: 'deleteOrganizationRelationship',
    isSelected: true
};
const fieldDefinitionCreateServiceLine = {
    key: 'CREATE_SERVICE_LINE',
    helpText: 'Create Service Line',
    required: false,
    type: 'checkbox',
    value: 'createServiceLine',
    isSelected: true
};
const fieldDefinitionUpdateServiceLine = {
    key: 'UPDATE_SERVICE_LINE',
    helpText: 'Update Service Line',
    required: false,
    type: 'checkbox',
    value: 'updateServiceLine',
    isSelected: true
};
const fieldDefinitionDeleteServiceLine = {
    key: 'DELETE_SERVICE_LINE',
    helpText: 'Delete Service Line',
    required: false,
    type: 'checkbox',
    value: 'deleteServiceLine',
    isSelected: true
};
const fieldDefinitionCreateEULA = {
    key: 'CREATE_EULA',
    helpText: 'Create EULA',
    required: false,
    type: 'checkbox',
    value: 'createEULA',
    isSelected: true
};
const fieldDefinitionUpdateEULA = {
    key: 'UPDATE_EULA',
    helpText: 'Update EULA',
    required: false,
    type: 'checkbox',
    value: 'updateEULA',
    isSelected: true
};
const formDefinitionDictionaryAction = {
    fieldGroups: [
        {
            label: 'Filter Dictionary Action',
            fields: [
                fieldDefinitionPublish,
                fieldDefinitionUpdate,
                fieldDefinitionDelete,
                fieldDefinitionCreate,
                fieldDefinitionAddRow,
                fieldDefinitionUpdateRow,
                fieldDefinitionPublishRow,
                fieldDefinitionArchiveRow,
                fieldDefinitionDeleteRow,
                fieldDefinitionUpdateDictionaryMetadata
            ]
        }
    ]
};
const formDefinitionOrganizationAction = {
    fieldGroups: [
        {
            label: 'Filter Organization Action',
            fields: [
                fieldDefinitionCreateOrganization,
                fieldDefinitionDeleteOrganization,
                fieldDefinitionUpdateOrganization,
                fieldDefinitionCreateOrganizationRelationship,
                fieldDefinitionDelteOrganizationRelationship,
                fieldDefinitionUpdateOrganizationRelationship,
                fieldDefinitionCreateServiceLine,
                fieldDefinitionDeleteServiceLine,
                fieldDefinitionUpdateServiceLine,
                fieldDefinitionCreateEULA,
                fieldDefinitionUpdateEULA
            ]
        }
    ]
};
const fieldDefinitionOrganization = {
    key: 'Organization Logs',
    helpText: 'Organization Logs',
    required: false,
    type: 'checkbox',
    value: 'organizationLogs',
    isSelected: true
};
const fieldDefinitionDictionary = {
    key: 'Dictionary Logs',
    helpText: 'Dictionary Logs',
    required: false,
    type: 'checkbox',
    value: 'dictionaryLogs',
    isSelected: true
};
const formDefinitionLogType = {
    fieldGroups: [
        {
            label: 'Filter Log Type',
            fields: [
                fieldDefinitionDictionary,
                fieldDefinitionOrganization
            ]
        }
    ]
};
const formDefinitionDate = {
    fieldGroups: [
        {
            label: 'Filter Service',
            fields: []
        }
    ]
};
export const dateCriteria = {
    name: 'Service Date',
    key: 'date_of_service',
    formDefinition: formDefinitionDate,
    isDate: true
};
export const logTypeCriteria = {
    name: 'Log Type',
    key: 'log_type',
    formDefinition: formDefinitionLogType,
    isColored: true
};
export const dictionaryActionCriteria = {
    name: 'Dictionary Event',
    key: 'dictionary_action',
    formDefinition: formDefinitionDictionaryAction,
    isColored: true
};
export const organizationActionCriteria = {
    name: 'Organization Event',
    key: 'organization_action',
    formDefinition: formDefinitionOrganizationAction,
    isColored: true
};
